import { IconDashboard, IconBook, IconMessage, IconShare, IconBriefcase, IconMessageChatbot } from '@tabler/icons-react';

const icons = {
  IconDashboard,
  IconBook,
  IconMessage,
  IconShare,
  IconBriefcase,
  IconMessageChatbot
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'dashboard',
  title: 'Dashboard',
  icon: icons.IconDashboard,
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.IconDashboard,
      breadcrumbs: false
    },
    {
      id: 'chat',
      title: 'Chat',
      type: 'item',
      url: '/chat',
      icon: icons.IconMessageChatbot
    },

    {
      id: 'knowledge-center',
      title: 'Knowledge Center',
      type: 'item',
      url: '/knowledge-center',
      icon: icons.IconBook,
      breadcrumbs: false
    },
    {
      id: 'mattermost',
      title: 'Mattermost',
      type: 'item',
      url: '/mattermost',
      icon: icons.IconMessage,
      breadcrumbs: false
    },
    {
      id: 'social-media',
      title: 'Social Media',
      type: 'item',
      url: '/social',
      icon: icons.IconShare
    },
    {
      id: 'internal-kit-corner',
      title: 'Internal Kit Corner',
      type: 'item',
      url: '/internal-kit-corner',
      icon: icons.IconBriefcase,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
